import LoyaltyCampaign from './LoyaltyCampaign';

export default LoyaltyCampaign;
